/**
 * Block Renderer Interface
 *
 * Interface Segregation Principle: Defines contract for block rendering
 * Dependency Inversion Principle: Components depend on abstraction
 */

import React from 'react';
import { ContentBlock } from '../parsers/MarkdownParser';
import { TextProcessorOptions } from '../processors/ITextProcessor';

export interface IBlockRenderer {
  /**
   * Render a content block to React node
   */
  render(
    block: ContentBlock,
    key: string,
    blockIndex: number,
    options?: TextProcessorOptions
  ): React.ReactNode;
}

export type { TextProcessorOptions };
